import React from 'react';
import { FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material';

export const PrevRadioElement = ({ item, label, value }) => {
    const options = (item?.properties?.options || []).filter((opt) => opt.name && opt.name.trim() !== '');

    return (
        <div>
            {/*<p className="preview-info-line-title" style={{ fontSize: 16 }}>{item?.label}</p>*/}
            <FormControl>
                <RadioGroup value={value?.id || ''}>
                    {options.map((opt) => (
                        <FormControlLabel
                            key={opt.id}
                            value={opt.id}
                            control={<Radio color="primary" style={{ padding: '4px 9px' }} />}
                            label={opt.name}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </div>
    );
};
